// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { GET_ORDERS_EXPORT_AVAILABLE_COLUMNS, getOrdersExportAvailableColumns } from 'src/redux/actions/orders/orders'
import { fetchOrdersExportAvailableColumns } from 'src/services/orders'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchFetchOrdersExportAvailableColumns(): Generator<IOEffect, void, any> {
  while (true) {
    yield take(GET_ORDERS_EXPORT_AVAILABLE_COLUMNS.REQUEST)

    try {
      const data = yield call(fetchOrdersExportAvailableColumns)

      yield put(getOrdersExportAvailableColumns.success(data))
    } catch (e) {
      yield put(getOrdersExportAvailableColumns.error(e.message))
    }
  }
}

export default [fork(watchFetchOrdersExportAvailableColumns)]
